<template>
  <div class="about-factory">
    <div class="about-factory-info">
      <h2>ABOUT HUBEI <span>RCH</span> <br> Enterprise</h2>
      <p>Hubei RCH Enterprise Co.,Limited is a professional underwater equipment manufacturer, headquartered in Yichang, Hubei, the capital of hydropower in China. The company has a R&D center and production factory in Jiangsu, integrating R&D, manufacturing and sales, with business scope all over the country and overseas.
        </p>
      <p>
        We are committed to providing customers with high-quality, high-reliability and sustainable solutions to meet the changing needs of the industry. After years of development and exploration, the company has successfully launched a series of independently developed deep-sea equipment, including underwater cameras, underwater video accessories,...
      </p>
      <div class="learn-more-button">
        <nuxt-link to="/about-us">
          <span>Learn More</span>
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

</script>

<style lang="stylus" scoped>
.about-factory
  margin 0 auto
  max-width 1920px
  height 600px
  background url("../assets/img/bg.jpg") no-repeat
  background-attachment fixed
  background-position top center
  background-size 1920px auto
  display flex
  align-items center
  .about-factory-info
    background linear-gradient(rgba(80,190,190,0.7),rgba(0,153,203,0.7))
    background-color: rgba(10,10,10,0.73);
    padding 25px
    width 620px
    box-sizing border-box
    margin-left 250px
    &>h2
      font-size 36px
      color #FFF
      margin-bottom 10px
      font-weight 300
      &>span
        font-weight 600
    &>p
      margin-top 15px
      color #FFF
      font-size 18px
      line-height 30px
      font-weight 300
    .learn-more-button
      width 140px
      height 40px
      border: 2px solid #FFF
      text-align center
      line-height 40px
      margin-top 15px
      position relative
      span
        color #FFF
      &:hover span
        color #000
        position relative
      &:before
        content ''
        position absolute
        left 0
        top 0
        width 0
        height 100%
        transition all .5s
      &:hover:before
        width 100%
        background #FFF
</style>
